<template>
  <section class="ugc-go-back-button row">
    <button
      type="button"
      @click="goBack"
      :disabled="toggleBackButton"
      :class="[
        'small-12 columns ugc-go-back-button-cta ugc-modal-button',
        { hide: hideButton }
      ]"
    >
      &lt; {{ translations.ugcModalBack }}
    </button>
  </section>
</template>
<script>
export default {
  name: "UgcGoBackButton",
  data() {
    return {
      isGoBackDisabled: true
    };
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    pdm() {
      return this.$store.state.utils.pdm;
    },
    hideButton() {
      if (this.$store.state.ugc.stateManager.currentUgcView == 0) {
        return true;
      }
      return false;
    },
    fabricCanvas() {
      return this.$store.state.ugc.stateManager.canvas;
    },
    activeUGCIndex() {
      return this.$store.state.ugc.tempData.activeUGCIndex;
    },
    placementViewOrder() {
      return this.$store.getters["ugc/tempData/getPlacementViewOrder"];
    },
    componentName() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].activeUGCComponent;
    },
    getSkipAlmostDone() {
      return this.$store.state.ugc.stateManager.skipAlmostDone;
    },
    getUgcFlowViews() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].ugcFlowViews;
    },
    getCurrentUgcView() {
      return this.$store.state.ugc.stateManager.currentUgcView;
    },
    getUgcFlowComponents() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].ugcFlowComponents;
    },
    toggleBackButton() {
      return (
        this.$store.state.ugc.stateManager.activeControl !== "" ||
        this.isGoBackDisabled
      );
    },
    isGCC() {
      return this.$store.getters["utils/isGCC"];
    },
    getMultipart() {
      return this.$store.getters["ugc/tempData/checkMultipart"];
    },
  },
  methods: {
    /**
     * @function calculateLastFlowIndex
     * Calculate the last index in ugc flow views.
     */
    calculateLastFlowIndex() {
      let stepBackward;
      if (this.getSkipAlmostDone) {
        for (let i = this.getCurrentUgcView; i > 0; i--) {
          if (this.getUgcFlowViews[i] == "ugc-almost-done") {
            stepBackward = i;
            break;
          }
        }
      } else {
        stepBackward = this.getCurrentUgcView - 1;
      }
      return stepBackward;
    },

    /**
     * @function goBack
     * This function does the following checks
     * if the event on the go back button should move back on the placement view
     * Or if it should go back on one of the 3 main ugc views (design-view, almost-done, confirm-design)
     * If the use has moved back to where there are no more placements views (placementViewOrder === 0)
     * The flow moves back the main view
     */
    goBack() {
      let stepBackward = this.calculateLastFlowIndex();

      this.$store.commit("ugc/stateManager/SET_LOADING", true);
      this.$eventBus.$emit("hide-customs-spinner", false);
      this.$eventBus.$emit("show-view-displayName", "");
      this.lockFabricMovement(true);
      this.$eventBus.$emit("disable-events-fabric-canvas");
      if (this.activeUGCIndex === 1 && stepBackward === -1) {
        this.$store.commit("imageGallery/PREV_VIEW");
        this.$eventBus.$emit("image-library-close-ugc", {goBack: true});
      } else if (
        this.getUgcFlowViews[this.getCurrentUgcView] !=
        this.getUgcFlowViews[stepBackward]
      ) {
        this.$store.commit(
          "ugc/stateManager/SET_CURRENT_UGC_VIEW",
          stepBackward
        );
        this.$store.commit("ugc/stateManager/SET_CANVAS", null);
        if(this.getUgcFlowViews[this.getCurrentUgcView] === "ugc-design-view") {
          if (this.activeUGCIndex === 1) {
            this.$store.commit("imageGallery/PREV_VIEW");
            this.$store.commit("imageGallery/SET_USE_SECOND_VIEW", false);
          }
          this.$store.commit("ugc/tempData/REMOVE_APPLY_UGC_COMPONENTS", this.componentName);
        }
        if (this.getUgcFlowViews[stepBackward] == "ugc-almost-done") {
          this.$store.commit("ugc/placements/CLEAR_COMPONENT_BUFFER", this.componentName);
          this.$store.commit("ugc/placements/CLEAR_COMPONENT_PLACEMENTS", this.componentName);
          if (this.$recipe.checkForUGCComponent(this.componentName)) {
            const component = {
              componentName: this.componentName,
              data: this.$store.state.recipe.recipe_v2.components[this.componentName]
            };
            this.$store.commit("ugc/tempData/UPDATE_COMPONENT", component);
          }
          if (this.activeUGCIndex === 1) {
            const { selectAnother, isReplaceTool } = this.$store.state.ugc.tempData.features[this.activeUGCIndex];
            const { useSameImage } = this.$store.state.imageGallery;
            const isSecondaryComponentFlow = this.$store.getters["imageGallery/isSecondComponentFlow"];
            if (this.getSkipAlmostDone) {
              // Back from confirm design if skipped on almostDone
              this.$store.commit("imageGallery/SET_ACTIVE_VIEW", this.getUgcFlowViews[stepBackward]);
              this.$store.commit("imageGallery/SET_CURRENT_UGC_VIEW", stepBackward);
            } else if ((selectAnother || isReplaceTool || !useSameImage) && isSecondaryComponentFlow) {
              // If back to almostDone but should be imageLibrary gallery view
              this.$store.commit("imageGallery/PREV_VIEW");
              this.$store.commit("imageGallery/SET_USE_SECOND_VIEW", false);

              this.$store.commit("imageGallery/SET_CURRENT_UGC_VIEW", this.getCurrentUgcView + 1);
              this.$eventBus.$emit('image-library-close-ugc', {isReplaceTool: true, selectAnother: true, goBack: true});
              return;
            } else {
              // TODO Image Library Reset 2nd component flow
              this.$store.commit("imageGallery/CLEAR_COMPONENT_SELECTED_IMAGE", {componentName: this.componentName});
              this.$store.commit("imageGallery/SET_SECOND_COMPONENT_FLOW", false);
              this.$store.commit("imageGallery/PREV_VIEW");
            }
          }
        }
        this.goBackMainView();
      } else if (
        this.getUgcFlowComponents[this.getCurrentUgcView] !=
        this.getUgcFlowComponents[stepBackward]
      ) {
        this.$store.commit(
          "ugc/stateManager/SET_CURRENT_UGC_VIEW",
          stepBackward
        );
        const currentComponent = this.getUgcFlowComponents[
          this.getCurrentUgcView
        ];
        this.$store.commit(
          "ugc/tempData/SET_ACTIVE_UGC_COMPONENT",
          currentComponent
        );
        this.resetStateManager();
        this.setPlacementViewOrder();
        this.goBackPlacementView();
        if (this.activeUGCIndex === 1) this.$store.commit("imageGallery/PREV_VIEW");
      } else {
        this.$store.commit("imageGallery/SET_USE_SECOND_VIEW", false);
        this.$store.commit(
          "ugc/stateManager/SET_CURRENT_UGC_VIEW",
          stepBackward
        );
        if (this.activeUGCIndex === 1) this.$store.commit("imageGallery/PREV_VIEW");
        this.$store.commit("ugc/tempData/UPDATE_PLACEMENT_VIEW_ORDER", false);
        this.goBackPlacementView();
      }
    },
    /**
     * @function goBackPlacementView
     * This function does the following:
     *  - Moves the placement view order back one step
     *  - Gets the canvas' json from the store
     *  - Sets the json into the fabric canvas
     *  - Renders the canvas
     *  - Enables the tools buttons
     */
    goBackPlacementView() {
      const canvasJSON = this.$store.state.ugc.placements.buffers[
        this.componentName
      ][this.placementViewOrder];
      this.fabricCanvas.loadFromJSON(canvasJSON, () => {
        this.fabricCanvas.renderAll.bind(this.fabricCanvas)();
        this.$eventBus.$emit("reload-placement-guide");
        this.lockFabricFeaturesOnBackEvent();
        this.lockFabricMovement(false, this.fabricCanvas.getObjects()[0]);
        this.$eventBus.$emit("enable-events-fabric-canvas");
      });
    },
    /**
     * @function setPlacementViewOrder
     * Set the last placement view order index.
     */
    setPlacementViewOrder() {
      if (this.getUgcFlowViews[this.getCurrentUgcView] !== "ugc-almost-done") {
        const placementIndex =
          this.pdm.components[this.componentName].ugc.placements.length - 1;
        if (
          this.getUgcFlowViews[this.getCurrentUgcView] === "ugc-design-view"
        ) {
          this.$store.commit(
            "ugc/tempData/SET_PLACEMENT_VIEW_ORDER",
            placementIndex
          );
          if (this.getMultipart > 1 && !this.$store.state.ugc.placements.responses[this.componentName]) {
            const { recipe } = this.$store.state.ugc.tempData.features[this.activeUGCIndex];
            const placements = recipe.components[this.componentName].ugc.placements;
            this.$store.commit("ugc/placements/SET_COMPONENT_PLACEMENTS", {
              index: this.placementViewOrder - 1,
              value: placements[0]
            });
            this.resetComponentData(recipe.components[this.componentName].ugc.original_image);

          }
        } else {
          this.$store.commit("ugc/tempData/RESET_PLACEMENT_VIEW_ORDER");
        }
      }
    },
    // TODO clear component buffers and placements??
    resetComponentData(originalImage = null) {
      if (!originalImage || !originalImage.hasOwnProperty('image_id') || !originalImage.hasOwnProperty('image_url')) {
        this.$store.commit("ugc/tempData/SET_UGC_IMAGE", {});
        return;
      }
      const { image_id, image_url } = originalImage;
      const fileFormat = image_url.split(".").pop();

      this.$store.commit("ugc/tempData/SET_UGC_IMAGE", {
        imagePath: image_url,
        temp_image_id: image_id,
        imageFormat: fileFormat
      });
    },
    /**
     * @function resetStateManager
     * Set the state manager with the last step for the specific component.
     */
    resetStateManager() {
      const { tempData } = this.$store.state.ugc;
      const stateManager = tempData.features[tempData.activeUGCIndex].stateManagers[
        this.componentName
      ];
      this.$store.commit("ugc/stateManager/SET_STATE_MANAGER", stateManager);
    },
    /**
     * @function goBackMainView
     * Create event to run when the canvas is loaded
     * Change ugc active component
     * Chance ugc view
     */
    goBackMainView() {
      this.$store.commit("ugc/tempData/CHANGE_UGC_ACTIVE_COMPONENT", true);
      this.setPlacementViewOrder();
      this.$eventBus.$once("image-set", this.loadCanvas);
      this.$store.commit("ugc/CHANGE_UGC_VIEW");
      this.disableGoBack(false);
    },
    loadCanvas() {
      const canvasJSON = this.$store.state.ugc.placements.buffers[this.componentName]
        && this.$store.state.ugc.placements.buffers[this.componentName][this.placementViewOrder];

      if (canvasJSON) {
        this.fabricCanvas.loadFromJSON(canvasJSON, () => {
          this.fabricCanvas.renderAll.bind(this.fabricCanvas)();
          this.$eventBus.$emit("reload-placement-guide");
          this.lockFabricFeaturesOnBackEvent();
          this.resetStateManager();
          this.$eventBus.$emit("hide-customs-spinner", true);
          this.lockFabricMovement(false, this.fabricCanvas.getObjects()[0]);
          this.$store.commit("ugc/stateManager/SET_LOADING", false);
        });
      }
    },
    /**
     * @function lockFabricMovement
     * Lock fabric movement between components transitions
     * When the canvas is loaded from JSON, the canvas is getting
     * by fabricCanvas.getObjects()[0]
     * Otherwise the currenct canvas is getting by fabricCanvas.getActiveObject()
     */
    lockFabricMovement(lock, fabricCanvas) {
      if (!this.fabricCanvas) {
        return;
      }
      let canvasObject = this.fabricCanvas.getActiveObject();
      if (fabricCanvas) {
        canvasObject = fabricCanvas;
      }
      if (!canvasObject) {
        return;
      }
      canvasObject.lockMovementX = lock;
      canvasObject.lockMovementY = lock;
      this.fabricCanvas.setActiveObject(canvasObject);
    },
    lockFabricFeaturesOnBackEvent() {
      const lock = this.placementViewOrder > 0 && !this.isGCC;

      this.$store.dispatch("ugc/LOCK_FABRIC_FEATURES", {
        fabricCanvas: this.fabricCanvas,
        lockFeatures: lock
      });
    },
    disableGoBack(disabled) {
      this.isGoBackDisabled = disabled;
    }
  },
  created() {
    this.$eventBus.$on("disable-next-back-buttons", this.disableGoBack);
  },
  beforeDestroy() {
    this.$eventBus.$off("disable-next-back-buttons", this.disableGoBack);
  }
};
</script>
